export default {
    cleanFilters: 'Limpar filtros',
    titleButton: 'Filtros',
    filtersTitle: 'Filtros',
    cleanFilter: 'Limpar filtros',
    apply: 'Aplicar',
    stateFilterLabel: 'Status',
    sponsorFilterLabel: 'Operadora',
    dateFilter: 'datas',
    dateFieldLabel: 'Período',
    documentationLabel: 'Documentação',
    documentation: 'Documentação: {satisfiesDocumentsPolicy}'
}